import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "chart" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode($setup["PrimeChart"], {
      type: "line",
      data: $options.chart_data,
      options: $options.chart_opt
    }, null, 8 /* PROPS */, ["data", "options"])
  ]))
}